<template>
  <div class="searchIndex">
    <van-search
      v-model="msg"
      background="#fff"
      show-action
      placeholder="请输入搜索关键词"
      @input="onSearch"
      @cancel="onCancel"
    />
    <!-- 展示列表 -->
    <div class="searchList">
      <div class="searchItem" v-for="(i, ind) in resultList" :key="ind">
        <van-icon name="clock-o" color="#999" size="14" />
        <div v-html="brightenKeyword(i.title, msg)" @click="goDetails(i)"></div>
        <van-icon name="cross" color="#999" size="14" />
      </div>
    </div>

    <div class="bottomText"> 本话术库由汇添富基金联合启势广告开发<br />
      版权所有。基金有风险，投资须谨慎</div>
  </div>
</template>

<script>
import { keywordList } from "@/api/index";
export default {
  name: "search",
  data() {
    return {
      msg: "",
      resultList: [],
      historyList: [],
    };
  },
  created() {
    this.msg = this.$route.query.msg;
    if (JSON.parse(localStorage.getItem("historyList"))) {
      this.historyList = JSON.parse(localStorage.getItem("historyList"));
    }
    if (this.msg) {
      this.onSearch(this.msg);
    }
  },
  methods: {
    onSearch(val) {
      // 没有搜索记录，把搜索值push进数组首位，存入本地
      // if (!this.historyList.includes(val)) {
      //   this.historyList.unshift(val);
      //   localStorage.setItem("historyList", JSON.stringify(this.historyList));
      // } else {
      //   //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
      //   let i = this.historyList.indexOf(val);
      //   this.historyList.splice(i, 1);
      //   this.historyList.unshift(val);
      //   localStorage.setItem("historyList", JSON.stringify(this.historyList));
      // }
      this.historyList.unshift(val);
      localStorage.setItem("historyList", JSON.stringify(this.historyList));
      keywordList({ title: val, type: 1 }).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.resultList = res.data.top_news;
        }
      });
    },
    onCancel() {
      this.$router.go(-1);
    },
    goDetails(i) {
      this.$router.push({
        path: "/details",
        query: {
          id: i.id,
        },
      });
    },
    //搜索高亮
    brightenKeyword(val, keyword) {
      if (keyword.length > 0) {
        let keywordArr = keyword.split("");
        val = val + "";
        console.log(keywordArr, val);
        keywordArr.forEach((item) => {
          if (val.indexOf(item) !== -1 && item !== "" && item !== "?") {
            val = val.replace(
              new RegExp(item, "g"),
              '<font color="#111111">' + item + "</font>"
            );
          }
        });
        return val;
      } else {
        return val;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.searchIndex {
  width: 94%;
  margin: 0 auto;
  position: relative;
  min-height: 90vh;
  padding-bottom: 60px;
  .van-search {
    padding: 0.625rem 0;
  }
  .van-search__content {
    padding-left: 0;
    background: #fff;
  }
  .van-search .van-cell {
    line-height: 32px;
    background: #f4f4f4;
    border-radius: 50px;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .searchList {
    width: 96%;
    margin: 0 auto;
    .searchItem {
      line-height: 2.1875rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.8125rem;
      div {
        flex: 2;
        color: #999;
        margin-left: 0.625rem;
      }
    }
  }
  .bottomText {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: .3rem;
    font-size: 0.75rem;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search.vue